<template>
   <div class="h-100">
      <div class="container-mobile">
         <div class="ajouter" @click="ajouterRuche"><b-icon icon="plus-circle" style="margin-right:8px;"></b-icon>Ajouter une nouvelle ruche</div>
      </div>
      <div class="sous-titre container-mobile">Filtrer par nom</div>
      <div class="container-mobile">
         <b-input v-model="filtre" placeholder="Saisissez les premières lettres du nom"></b-input>
      </div>
      <div class="spinner-container" v-if="loading">
         <BeatLoader color="#1389EF" />
      </div>
      <div v-else>
         <div v-if="ruchesFiltrees.length === 0" style="text-align:center">Aucun élément à afficher</div>
         <div class="liste">
            <div v-for="ruche in ruchesFiltrees" :key="ruche.id" class="liste-item" @click="goToRuche(ruche.id)">
               <div>
                  {{ ruche.nom }}
                  <b-icon icon="star" size="is-small" type="is-warning" v-if="ruche.elite" />
               </div>
               <div class="liste-icones">
                  <div @click.stop="editRuche(ruche.id)">
                     <b-icon icon="pencil" class="edit"></b-icon>
                  </div>
                  <div @click.stop="deleteRuche(ruche.nom, ruche.id)">
                     <b-icon icon="delete" class="del"></b-icon>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import axios from 'axios';
import { BeatLoader } from '@saeris/vue-spinners';

export default {
   components: { BeatLoader },
   data() {
      return {
         loading: true,
         ruches: [],
         filtre: ''
      };
   },
   mounted() {
      // Régler le titre
      this.$store.commit('setTitre', 'Ruches');
      // récupérer les ruches
      this.getRuches();
   },
   computed: {
      ruchesFiltrees() {
         if (this.filtre.length > 0) {
            return this.ruches.filter(ruche => ruche.nom.toLowerCase().includes(this.filtre.toLowerCase()));
         }
         return this.ruches;
      },
      user() {
         return this.$store.state.user;
      }
   },
   methods: {
      async getRuches() {
         this.loading = true;
         axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.token;
         let res = await axios.get('/ruches');
         this.ruches = res.data.data;
         this.loading = false;
      },
      goToRuche(id) {
         this.$router.push({
            name: 'ruches.show',
            params: {
               id: id
            }
         });
      },
      editRuche(id) {
         this.$router.push({
            name: 'ruches.edit',
            params: {
               id: id
            }
         });
      },
      deleteRuche(nom, id) {
         this.$buefy.dialog.confirm({
            message: 'Souhaitez-vous vraiment supprimer: ' + nom + ' ? Vous supprimerez également son historiques et les statistiques associées. Cette action est irréversible.',
            cancelText: 'Non',
            confirmText: 'Oui',
            type: 'is-danger',
            hasIcon: true,
            onConfirm: () => {
               this.loading = true;
               axios.delete('/ruches/' + id).then(res => {
                  if (res.data.erreur) {
                     this.$buefy.toast.open({
                        message: res.data.erreur,
                        type: 'is-danger'
                     });
                     this.getRuches();
                  } else {
                     this.$buefy.toast.open({
                        message: 'Ruche supprimée avec succès',
                        type: 'is-success'
                     });
                     this.loading = false;
                     this.ruches = this.ruches.filter(ruche => ruche.id != id);
                  }
               });
            }
         });
      },
      ajouterRuche() {
         this.$store.dispatch('getUser').then(() => {
            if (this.user.ruches < 10) {
               this.$router.push({ name: 'ruches.create' });
            } else {
               if (this.user.abonnement && this.user.abonnement.stripe_status === 'active') {
                  this.$router.push({ name: 'ruches.create' });
               } else {
                  this.$buefy.dialog.confirm({
                     title: 'Limite atteinte',
                     message: 'Vous avez atteint la limite de 10 ruches autorisées dans la version gratuite. Abonnez-vous à BeePerf Premium pour pouvoir continuer à gérer des ruches supplémentaires ou bien supprimez des ruches existantes.',
                     cancelText: 'Retour',
                     confirmText: "S'abonner",
                     icon: 'information',
                     hasIcon: true,
                     onConfirm: () => this.$router.push({ name: 'abonnement' })
                  });
               }
            }
         });
      }
   }
};
</script>

<style></style>
